import type { DataPoint, ProviderFile } from "@/fileParsing/types";
import type { MappingJSON, Mappings, ParserJSON, ParserObject, Purpose, Retention, Sharing } from "./policyParserTypes";
import { mappings } from "./sankeyResources/Mappings/index";
import { outputs } from "./sankeyResources/Outputs";

export function mapDataPointToPolicyAttributes(
  dataPoint: DataPoint,
  file: ProviderFile,
  mapping: MappingJSON,
  output: ParserJSON,
) {
  const fileName = file.fileName;
  const policyCategories = (mapping.mappings ?? [])
    .filter((m: Mappings) => m.titles.includes(fileName))
    .map((m: Mappings) => m.category);
  //const policyCategories = !dataPoint.policyCategory ? categories : [...dataPoint.policyCategory, ...categories];
  const purposeClause = new Set<string>(dataPoint.purposes ?? []);
  const sharingClause = new Set<string>(dataPoint.sharing ?? []);
  const retentionClause = new Set<string>(dataPoint.retention ?? []);

  policyCategories.forEach((pc: string) => {
    const matches = output.outputs.filter((o) => o.category === pc);
    matches.forEach((match: ParserObject) => {
      (match.purposes ?? []).forEach((p: Purpose) => {
        purposeClause.add(p.reason);
      });
      (match.sharing ?? []).forEach((s: Sharing) => {
        sharingClause.add(s.party);
      });
      (match.retention ?? []).forEach((r: Retention) => {
        retentionClause.add(r.duration);
      });
    });
  });

  dataPoint.policyCategory = policyCategories;
  dataPoint.purposes = purposeClause;
  dataPoint.retention = retentionClause;
  dataPoint.sharing = sharingClause;

  return dataPoint;
}

export function deserializeOutputs(providers: string[]) {
  const deserialized: Record<string, [MappingJSON, ParserJSON]> = {};

  providers.forEach((providerId) => {
    let provider = providerId;

    if (provider === "wrangled") {
      provider = "netflix.com";
    }

    //get matching mappingJSON and parserJSON
    const mappingJSON = {
      provider,
      mappings: mappings[provider],
    };

    if (provider === "facebook.com" || provider === "instagram.com" || provider === "sample") {
      provider = "meta";
    }
    const outputJSON = { provider, outputs: outputs[provider] };
    deserialized[providerId] = [mappingJSON, outputJSON]; // it will be called with original ID
  });
  return deserialized;
}
